import _debounce from 'lodash/debounce';

/**
 * Lodash's debounce which queues caller arguments.
 * @param {function} callback - callback which will receive the queue
 * @param {number} timeout - debounce timeout
 * @param {object} debounceOptions - debounce options
 * @returns {function} - debounced function
 */
export function debounceWithQueue(callback: any, timeout: number, debounceOptions = {}) {
	let queue = [];

	const runCallback = () => {
		callback(queue);
		queue = [];
	};

	const debounced = _debounce(runCallback, timeout, debounceOptions);

	const queuedDebounce = (arg: any) => {
		queue.push(arg);
		debounced();
	};

	return queuedDebounce;
}
